if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
document.addEventListener('DOMContentLoaded', () => {
  const MG = customElements.get('media-gallery');
  if (!MG) return;

  // === Android Chrome Focus Trap Protection ===
  // Intercept touch/pointer events on media elements to trap focus inside the gallery container
  // and prevent Android Chrome FocusController from falling back to Quantity inputs.
  ['touchstart', 'pointerdown'].forEach((evtType) => {
    window.addEventListener(evtType, (e) => {
      const mediaEl = e.target.closest('media-gallery, .product-media-container, deferred-media, video');
      if (mediaEl) {
        if (typeof mediaEl.focus === 'function') {
          try { mediaEl.focus({ preventScroll: true }); } catch (err) {}
        }
        if (document.activeElement && document.activeElement.tagName === 'INPUT') {
          try { document.activeElement.blur(); } catch (err) {}
        }
      }
    }, { passive: true, capture: true });
  });

  MG.prototype.playActiveMedia = function (activeItem) {
    if (!activeItem) return;

    const video = activeItem.querySelector('video');

    document.querySelectorAll('video').forEach((v) => {
      if (v !== video) {
        if (!v.paused) v.pause();
        const opener = v.closest('.product-media-container')?.querySelector('.product__modal-opener');
        if (opener) opener.style.removeProperty('display');
        const defMedia = v.closest('.deferred-media');
        if (defMedia && window.innerWidth < 750) defMedia.style.removeProperty('display');
      }
    });

    const deferredMedia = activeItem.querySelector('.deferred-media');
    if (deferredMedia && typeof deferredMedia.loadContent === 'function' && !deferredMedia.hasAttribute('loaded')) {
      deferredMedia.loadContent(false);
    }

    if (deferredMedia) {
      deferredMedia.style.display = 'block';
    }

    const activeVideo = activeItem.querySelector('video');
    if (activeVideo) {
      activeVideo.setAttribute('playsinline', '');
      activeVideo.setAttribute('webkit-playsinline', '');
      activeVideo.setAttribute('tabindex', '-1');
      activeItem.setAttribute('tabindex', '-1');
      try {
        activeItem.focus({ preventScroll: true });
      } catch (e) {}

      const modalOpener = activeItem.querySelector('.product__modal-opener');
      if (modalOpener) modalOpener.style.display = 'none';

      const doPlay = () => {
        activeVideo.muted = false;
        const playPromise = activeVideo.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {
            // Fallback for mobile autoplay policy restrictions (e.g. initial load without prior gesture)
            activeVideo.muted = true;
            activeVideo.play().catch(() => { });
          });
        }
      };

      if (activeVideo.readyState >= 2) {
        doPlay();
      } else {
        activeVideo.addEventListener('canplay', doPlay, { once: true });
        activeVideo.addEventListener('loadeddata', doPlay, { once: true });
        try {
          activeVideo.load();
        } catch (e) { }
        doPlay();
      }
    }
  };

  let userInteracted = false;
  const enableAudioOnUserGesture = () => {
    if (userInteracted) return;
    userInteracted = true;
  };
  ['touchstart', 'touchend', 'click', 'pointerdown', 'scroll'].forEach((eventType) => {
    window.addEventListener(eventType, enableAudioOnUserGesture, { passive: true });
  });

  document.querySelectorAll('media-gallery').forEach((gallery) => {
    if (gallery.elements && gallery.elements.viewer) {
      gallery.elements.viewer.addEventListener('slideChanged', (e) => {
        gallery.playActiveMedia(e.detail.currentElement);
      });
    }

    const sliderList = gallery.querySelector('ul.product__media-list');
    if (!sliderList) return;

    if (window.innerWidth < 750) {
      const activeSlide = sliderList.querySelector('.product__media-item.is-active') || sliderList.querySelector('.product__media-item');
      if (activeSlide) {
        gallery.playActiveMedia(activeSlide);
        setTimeout(() => gallery.playActiveMedia(activeSlide), 300);
        setTimeout(() => gallery.playActiveMedia(activeSlide), 800);
      }
    }

    let scrollTimeout;
    const handleScrollSettled = () => {
      if (window.innerWidth >= 750) return;

      const slides = sliderList.querySelectorAll('.product__media-item');
      const containerRect = sliderList.getBoundingClientRect();
      let bestSlide = null;
      let bestOverlap = 0;

      slides.forEach((slide) => {
        const rect = slide.getBoundingClientRect();
        const overlap =
          Math.max(0, Math.min(rect.right, containerRect.right) - Math.max(rect.left, containerRect.left));
        if (overlap > bestOverlap) {
          bestOverlap = overlap;
          bestSlide = slide;
        }
      });

      if (bestSlide) gallery.playActiveMedia(bestSlide);
    };

    sliderList.addEventListener(
      'scroll',
      () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(handleScrollSettled, 150);
      },
      { passive: true }
    );
  });
});

